




















import { Component, Mixins, Prop } from 'vue-property-decorator'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ModalBaseMethod from '@/mixins/ModalBaseMethod.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import MovieBase from '@/components/common/atoms/MovieBase.vue'
import StudySelectionApis from '@/mixins/requests/student/StudySelectionApis.vue'
import { STUDY_MODE_CODE, StudyModeCodeType } from '@/constants/ApiConstant'

@Component({
  components: {
    ModalBase,
    ButtonBase,
    MovieBase,
    StudySelectionApis,
  },
})
export default class ModalStudySelection extends Mixins(ModalBaseMethod, StudySelectionApis) {
  private videoUrl = ''

  /** 授業モードコード */
  @Prop({ default: STUDY_MODE_CODE['normal'] })
  studyModeCode!: StudyModeCodeType
  /** 中断状態判定 */
  @Prop()
  isAutoLevelSelection!: boolean
  /** 利用可能レベル一覧 */
  @Prop()
  availableStartLevels!: number[]

  /** レベル別ボタン表示文言一覧 */
  private BUTTON_TEXT_BY_LEVEL = {
    1: 'レベル１（基礎問題）',
    2: 'レベル２（標準問題）',
    3: 'レベル３（発展問題）',
  }

  /** 授業モードコード定数参照 */
  private STUDY_MODE_CODE(keyName: string) {
    return STUDY_MODE_CODE[keyName]
  }

  private async mounted() {
    try {
      this.videoUrl = await this.loadVideoUrl()
    } catch (e) {
      if (e.response && e.response.data && e.response.data.status === 404) {
        alert('テスト説明動画が見つかりません')
      }
    }
  }

  private onClickStartButton(startLevel: number | null) {
    this.$emit('start', startLevel)
    this.hide()
  }
}
